<template>
  <div id="app">
    <credit-limit-modal></credit-limit-modal>
    <unlock-pro-modal></unlock-pro-modal>
    <max-concurrent-limit-modal></max-concurrent-limit-modal>
    <generic-error-modal></generic-error-modal>
    <job-failed-modal></job-failed-modal>
    <feedback-modal></feedback-modal>

    <BaseLayout v-if="creatorStudio.isMobile === false">
      <template v-slot:topbar>
        <router-view name="Topbar"></router-view>
      </template>
      <template v-slot:sidebar-left>
        <router-view name="SidebarLeft"></router-view>
      </template>
      <template v-slot:main-canvas>
        <router-view></router-view>
      </template>
      <template v-slot:sidebar-right>
        <router-view name="SidebarRight"></router-view>
      </template>
    </BaseLayout>

    <MobileLayout v-if="creatorStudio.isMobile === true">
      <template v-slot:main-canvas>
        <router-view name="MobileDefault"></router-view>
      </template>
      <template v-slot:mobile-secondary-navbar>
        <router-view name="MobileSecondaryNavbar"></router-view>
      </template>
      <template v-slot:mobile-navbar>
        <router-view name="MobileNavbar"></router-view>
      </template>
    </MobileLayout>
  </div>
</template>
<script>
import store from './mixins/store.mixin'
import JobManager from "./manager/JobManager";
import BaseLayout from "./layout/BaseLayout.vue";
import {EventBus} from "./events/event.bus";
import {EVENT_APP_NAVIGATE} from "./events/app.events";
import StudioManager from "./manager/StudioManager";
import MobileLayout from "./layout/MobileLayout.vue";
import CreditLimitModal from "./components/Modal/CreditLimitModal.vue";
import UnlockProModal from "./components/Modal/UnlockProModal.vue";
import MaxConcurrentLimitModal from "./components/Modal/MaxConcurrentLimitModal.vue";
import FeedbackModal from "./components/Modal/FeedbackModal.vue";
import GenericErrorModal from "./components/Modal/Error/GenericErrorModal.vue";
import JobFailedModal from "./components/Modal/Error/JobFailedModal.vue";

export default {
  name: "AiCreatorStudio",
  components: {
    JobFailedModal,
    FeedbackModal,
    GenericErrorModal,
    MaxConcurrentLimitModal,
    CreditLimitModal,
    UnlockProModal,
    BaseLayout,
    MobileLayout,
  },
  mixins: [
    store,
  ],
  data() {
    return {
      event_app_navigate: EVENT_APP_NAVIGATE,
      listener: false,
    };
  },
  created: function () {
    if (this.listener === false) {
      JobManager.listen();
      StudioManager.watchMobile();
      this.navigationListener();
      this.listener = true;
    }

    StudioManager.updateMobile();
    StudioManager.openWelcomeJob();
  },
  mounted: function () {
  },
  methods: {
    navigationListener() {
      EventBus.$on(this.event_app_navigate, (route, params, query = {}, replace = false) => {
        if (replace === true) {
          query.rand = Math.floor(Math.random() * 100);
          this.$router.replace({path: route, params: params, query: query});
        } else {
          query.rand = Math.floor(Math.random() * 100);
          this.$router.push({path: route, params: params, query: query});
        }
      })
    },
  },
  computed: {},
};
</script>
<style lang="scss">
#app {
  .glow {
    animation: glow 1s infinite alternate, delay-animation 4s linear infinite;
    animation-delay: 30s;

  }

  .glow-btn {
    animation: glow 1s infinite alternate;
    animation-delay: 1s;
  }

  @keyframes delay-animation {
    0% {
    }
    50% {

    }
    50.01% {
      box-shadow: none;
    }
    100% {
      box-shadow: none;
    }
  }

  @-webkit-keyframes glow {
    0% {
      -webkit-transform: scale(0.97);
      transform: scale(0.97);
    }

    25% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }

    60% {
      -webkit-transform: scale(0.97);
      transform: scale(0.97);
    }

    100% {
      -webkit-transform: scale(0.97);
      transform: scale(0.97);
    }
  }

  @keyframes glow {
    0% {
      -webkit-transform: scale(0.97);
      -ms-transform: scale(0.97);
      transform: scale(0.97);
    }

    25% {
      -webkit-transform: scale(1);
      -ms-transform: scale(1);
      transform: scale(1);
    }

    60% {
      -webkit-transform: scale(0.97);
      -ms-transform: scale(0.97);
      transform: scale(0.97);
    }

    100% {
      -webkit-transform: scale(0.97);
      -ms-transform: scale(0.97);
      transform: scale(0.97);
    }
  }


  height: calc(100% - 65px);
  background: black;

  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-button {
    width: 8px;
    height: 0;
  }

  ::-webkit-scrollbar-track {
    background: #2e2e2e;
    border: thin solid lightgray;
    border-radius: 0;
    border-top: 0;
    border-bottom: 0;
  }

  ::-webkit-scrollbar-thumb {
    background: lighten(#2e2e2e, 15%);
    border: thin solid #999;
    border-radius: 0;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #7d7d7d;
  }

  .badge-warning {
    cursor: pointer;
  }
}
</style>
